import styled from 'styled-components';

export const HeaderTotalSummaryContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  & p {
    margin: 0;
  }
  & p:not(:first-child) {
    justify-self: end;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    & p {
      justify-self: start;
    }
    & p:not(:first-child) {
      justify-self: start;
    }
  }
  @media (max-width: 576px) {
    grid-template-columns: 2fr repeat(2, 1fr);
  }
`;
